export default __webpack_public_path__ + "static/media/Gesture icons_Hit.579e5d60.svg";